var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadWindows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_523_2423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.45459,
    width: 53,
    height: 53,
    rx: 9.63636,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_2423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9192 16.0615C30.3748 15.3796 34.8386 14.7379 39.303 14.1182C39.3061 18.0306 39.303 21.9398 39.3061 25.8522C34.8449 25.8691 30.3836 25.9369 25.9198 25.9513C25.9167 22.653 25.9167 19.3573 25.9198 16.0615H25.9192Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6035 17.6402C17.9589 17.1227 21.328 16.6754 24.6972 16.2539C24.7003 19.4989 24.7003 22.7407 24.7028 25.9856C21.3362 25.9825 17.9702 26.0339 14.6035 26.0252V17.6402Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6035 27.0465C17.967 27.0352 21.3305 27.0891 24.6941 27.0835C24.6941 30.3366 24.7028 33.5897 24.6972 36.8434C21.3362 36.3454 17.9702 35.91 14.6035 35.4546V27.0471L14.6035 27.0465Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8991 27.1768H39.3023C39.3079 31.0779 39.3023 34.979 39.3023 38.8826C34.8467 38.2151 30.3829 37.5954 25.9185 36.99C25.9129 33.72 25.9041 30.4493 25.8984 27.1768H25.8991Z",
    fill: "#A8A8A8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_523_2423",
    x: 0.45459,
    y: 0,
    width: 54.2045,
    height: 54.2045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.20455,
    dy: 1.20455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.21591
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_523_2423"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_2423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.7019,
    height: 24.764,
    fill: "white",
    transform: "translate(14.6035 14.1182)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWindows);
export default __webpack_public_path__ + "static/media/download_windows.26a975ce.svg";
export { ForwardRef as ReactComponent };